import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { theme } from '@styles/theme';
import { Loader2 } from 'lucide-react';
const variantStyles = {
    primary: css `
    background-color: ${theme.colors.accent.primary};
    color: ${theme.colors.background.primary};
    border: 1px solid ${theme.colors.accent.primary};

    &:hover:not(:disabled) {
      background-color: ${theme.colors.accent.hover};
      border-color: ${theme.colors.accent.hover};
    }
  `,
    secondary: css `
    background-color: transparent;
    color: ${theme.colors.text.primary};
    border: 1px solid ${theme.colors.border.primary};

    &:hover:not(:disabled) {
      background-color: ${theme.colors.background.tertiary};
      border-color: ${theme.colors.border.secondary};
    }
  `,
    ghost: css `
    background-color: transparent;
    color: ${theme.colors.text.primary};
    border: 1px solid transparent;

    &:hover:not(:disabled) {
      background-color: ${theme.colors.background.tertiary};
    }
  `,
    danger: css `
    background-color: ${theme.colors.status.error};
    color: ${theme.colors.text.primary};
    border: 1px solid ${theme.colors.status.error};

    &:hover:not(:disabled) {
      background-color: #DC2626;
      border-color: #DC2626;
    }
  `,
};
const sizeStyles = {
    sm: css `
    padding: ${theme.spacing.xs} ${theme.spacing.sm};
    font-size: ${theme.typography.fontSize.sm};
    gap: ${theme.spacing.xs};
  `,
    md: css `
    padding: ${theme.spacing.sm} ${theme.spacing.md};
    font-size: ${theme.typography.fontSize.md};
    gap: ${theme.spacing.sm};
  `,
    lg: css `
    padding: ${theme.spacing.md} ${theme.spacing.lg};
    font-size: ${theme.typography.fontSize.lg};
    gap: ${theme.spacing.sm};
  `,
};
const StyledButton = styled.button `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: ${theme.typography.fontFamily};
  font-weight: ${theme.typography.fontWeight.medium};
  border-radius: ${theme.borderRadius.md};
  transition: all ${theme.transitions.fast};
  cursor: pointer;
  white-space: nowrap;

  ${({ $variant }) => variantStyles[$variant]}
  ${({ $size }) => sizeStyles[$size]}
  ${({ $fullWidth }) => $fullWidth && css `width: 100%;`}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  ${({ $loading }) => $loading &&
    css `
      cursor: wait;
      pointer-events: none;
    `}
`;
const SpinnerIcon = styled(Loader2) `
  animation: spin 1s linear infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;
export function Button({ variant = 'primary', size = 'md', fullWidth = false, loading = false, leftIcon, rightIcon, children, disabled, ...props }) {
    return (_jsxs(StyledButton, { "$variant": variant, "$size": size, "$fullWidth": fullWidth, "$loading": loading, disabled: disabled || loading, ...props, children: [loading ? _jsx(SpinnerIcon, { size: size === 'sm' ? 14 : size === 'md' ? 16 : 18 }) : leftIcon, children, !loading && rightIcon] }));
}
